//
//
//
//
//
//
//
//

import { CatPreviewLocation } from 'counselor-mobile-ui'

export default {
  components: { CatPreviewLocation },

  computed: {
    longitude () {
      return this.$route.params.lon
    },

    latitude () {
      return this.$route.params.lat
    },
  },

}
